<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-search-table ref="table" :items.sync="values" :title="title" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {SearchModel} from "@/modules/redactor/models/search/SearchModel";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RSearchTable from "@/modules/redactor/views/search/r-search-table";


export default {
  name: "r-search-panel",
  components: {RPanel, RSearchTable},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Search"),
    items: VueTypes.arrayOf(SearchModel)
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>